import React, { useState } from "react";
import {
  Card,
  CardContent,
  Box,
  Typography,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import {
  Edit as EditIcon,
  Check as CheckIcon,
  Close as CloseIcon,
  AccountBalance as TaxIcon,
} from "@mui/icons-material";

const TaxRateCard = ({
  businessSettings,
  taxRateValue,
  setTaxRateValue,
  onUpdateTaxRate,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleSave = async () => {
    const success = await onUpdateTaxRate(taxRateValue);
    if (success) {
      setIsEditing(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    setTaxRateValue(businessSettings?.income_tax_rate?.toString() || "12");
  };

  return (
    <Card
      sx={{
        mb: 3,
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <TaxIcon sx={{ color: "white", mr: 1, fontSize: 28 }} />
          <Typography variant="h6" sx={{ color: "white", fontWeight: 600 }}>
            Stawka Podatku Dochodowego
          </Typography>
        </Box>

        {isEditing ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <TextField
              value={taxRateValue}
              onChange={(e) => setTaxRateValue(e.target.value)}
              type="number"
              size="small"
              sx={{
                bgcolor: "white",
                borderRadius: 1,
                width: 120,
                "& .MuiInputBase-root": { bgcolor: "white" },
              }}
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
            />
            <IconButton
              onClick={handleSave}
              sx={{
                color: "white",
                bgcolor: "rgba(255,255,255,0.2)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
              }}
            >
              <CheckIcon />
            </IconButton>
            <IconButton
              onClick={handleCancel}
              sx={{
                color: "white",
                bgcolor: "rgba(255,255,255,0.2)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        ) : (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="h3" sx={{ color: "white", fontWeight: 700 }}>
              {businessSettings?.income_tax_rate || 12}%
            </Typography>
            <IconButton
              onClick={() => setIsEditing(true)}
              sx={{
                color: "white",
                bgcolor: "rgba(255,255,255,0.2)",
                "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
              }}
            >
              <EditIcon />
            </IconButton>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default TaxRateCard;
